import { colors, Stack } from '@ui-components/neo.tax';
import React from 'react';

import { StyledTypography } from './rd-percent-cell.styled';

interface PercentCellProps {
  onClick: () => void;
  percent: number;
  isSelected?: boolean;
}

export const PercentCell = ({ isSelected = false, onClick, percent }: PercentCellProps): React.ReactElement => (
  <Stack direction="row" justifyContent="end" fullWidth>
    <StyledTypography
      as="button"
      onClick={onClick}
      fontSize="sm"
      fontWeight="medium"
      color={isSelected ? colors.white : colors.primary[500]}
    >
      {percent}%
    </StyledTypography>
  </Stack>
);
